import { render, staticRenderFns } from "./reisetermin-card-aufgaben.vue?vue&type=template&id=cdc80ea6"
import script from "./reisetermin-card-aufgaben.vue?vue&type=script&lang=js"
export * from "./reisetermin-card-aufgaben.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-card-aufgaben.vue?vue&type=style&index=0&id=cdc80ea6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports